import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router'

import Icon from '../../shared/components/Icon'

const MainNavItem = ({
  active, url, title, icon, badge
}) => {
  return (
    <li>
      <Link
        to={url}
        title={title}
        className={classNames({ active })}
      >
        <Icon
          className="nav-icon"
          name={icon}
        />
        {badge
          ? (
            <span
              className="badge"
            >
              {badge}
            </span>
          )
          : null}
      </Link>
    </li>
  )
}

MainNavItem.propTypes = {
  active: PropTypes.bool,
  badge: PropTypes.number,
  icon: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
}

export { MainNavItem as default }



// WEBPACK FOOTER //
// ./src/base/components/MainNavItem.js